<template>
  <div class="debug-docs ml-2">
    <h2>Debugging Tests</h2>
    <div class="mt-4">
      <div>Starting from version 1.2 it is now possible to use PyCharm remote debugger to attach to the running test.</div>
      <p class="mt-3">This is particularly useful for debugging Django tests, as standard PyCharm executor will create database each run, while <router-link to="/docs/django-support">PyCrunch concept is a bit different</router-link>.</p>
      <p class="mt-3">To start using debugger, first, make sure you have installed bundled <code>pydevd-pycharm</code> package by running</p>
      <p class="mt-3"><code>pip install pydevd-pycharm</code></p>
      <p class="mt-3">Correct command/version can be retrieved from the Edit Configurations window:</p>
      <div><img class="img-fluid" style="width: 1000px" src="../../assets/docs/debug-example.png"></div>
      <p class="mt-3">After this, put breakpoint in your code and run test via debug from PyCrunch window:</p>
      <div><img class="img-fluid mb-4" style="width: 466px" src="../../assets/docs/debug-button.png"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'docs-debugging-support.page',
  }
</script>

<style scoped>

</style>